import { ICommandBase } from '@/commands/interface/iCommandBase';
import { TableLayer } from '@/model/document2/page/surface/design/layer/tableLayer';
import { TableCellInfo } from '@/model/document2/page/surface/design/layer/table/tableCellInfo';

// 表レイヤーのセル情報変更コマンド
export class ChangeTableCellInfoCommand implements ICommandBase
{
    private layer! : TableLayer;
    private propertyName! : string;
    private value! : any;
    private doneCallback! : () => void;

    private row : number = 0;
    private column : number = 0;

    private oldCellInfo;

    constructor(layer : TableLayer, row : number, column : number, propertyName : string, value : number, doneCallback : () => void)
    {
        this.layer = layer;
        this.propertyName = propertyName;
        this.value = value;
        this.doneCallback = doneCallback;

        this.row = row;
        this.column = column;

        // 現在の値を保持
        this.oldCellInfo = layer.getCellInfo(this.row, this.column);
    }

    public do() : void
    {
        var newCellInfo = this.layer.getCellInfo(this.row, this.column).clone();
        // 新しい値を設定
        newCellInfo[this.propertyName] = this.value;
        // 適用
        this.layer.setCellInfo(this.row, this.column, newCellInfo);

        this.doneCallback();
    }

    public undo() : void
    {
        // 前の値を設定
        this.layer.setCellInfo(this.row, this.column, this.oldCellInfo);

        this.doneCallback();
    }

    public redo() : void
    {
        var newCellInfo = this.layer.getCellInfo(this.row, this.column).clone();
        // 新しい値を設定
        newCellInfo[this.propertyName] = this.value;
        // 適用
        this.layer.setCellInfo(this.row, this.column, newCellInfo);
        
        this.doneCallback();
    }
}